import ServiceApi from "../ServiceApi";
class MailerServiceApi extends ServiceApi {
  constructor() {
    super("mailerService", "mailer");
  }
  getSubscriptionStatus() {
    return this.request("getSubscriptionStatus");
  }

  /**
   *
   * @param [email]
   */
  sendCheckMail(email) {
    let params = {};
    if (email) {
      params.email = email;
    }
    return this.request("subscribe", params);
  }
  /**
   * Change user's email to new.
   * After this you must use sendCheckMail
   * @param [email]
   */
  changeAltEmail(email) {
    let params = {};
    if (email) {
      params.email = email;
    }
    return this.request("changeAltEmail", params);
  }
  subscribeAccept(url_params) {
    return this.request("accept", url_params);
  }
  getMailerSubscriptions(token) {
    let params = {
      token: token,
    };
    return this.request("getMailerSubscriptions", params);
  }
  getMailerProfile(params) {
    return this.request("getMailerProfile", params);
  }

  /**
   * example (if we have token): {token: "kjn21jnk1nf"}
   * @param params
   * @returns {*}
   * response example: {
    "id": null,
    "result": {
    "bounce_at": null,
    "can_change_email": false,
    "can_change_email_in_account": true,
    "email": "god_aw_29_7_19_fnybo@mail.ru",
    "email_verified": true,
    "spam_reported_at": null,
    "subscribed_at": 1589970460,
    "subscribed_categories": [1,2,3],
    "unsubscribed_at": null
  }
}
   */
  getAccountSubscriptionsStatus(params = {}) {
    return this.request("getAccountSubscriptionsStatus", params);
  }
  /**
   * example (if we need change email): {email: "new_email@test.com"}
   * @param params
   * @returns {*}
   */
  accountSubscribe(params = {}) {
    return this.request("accountSubscribe", params);
  }
}
export default new MailerServiceApi();
